const UiCarouselSeamlessPropsOption = {
  delay: { type: Number, default: 2 },
  //* 切换的间隔
  height: { type: [String, Number], required: true }
  //* 轮播图高度, 支持10px, 10vh, 10
};

export { UiCarouselSeamlessPropsOption };
//# sourceMappingURL=index.mjs.map
